export var PROJECT_NETWORK_LABEL = 'Rede';
export var PROJECT_NETWORK_TEXTS = {
    menuLabel: 'Redes',
    pageTitle: 'Redes',
    pageDescription: 'Cadastro de redes vinculadas aos projetos',
    newButton: 'Nova rede',
    searchLabel: 'Busca',
    searchPlaceholder: 'Buscar por nome ou sigla',
    statusLabel: 'Status',
    allStatus: 'Todos',
    activeStatus: 'Ativas',
    inactiveStatus: 'Inativas',
    clearFilters: 'Limpar',
    columns: {
        name: 'Nome',
        acronym: 'Sigla',
        color: 'Cor',
        status: 'Status',
        actions: 'Ações',
    },
    active: 'Ativa',
    inactive: 'Inativa',
    emptyMessage: 'Nenhuma rede encontrada',
    emptyTitle: 'Nenhuma rede cadastrada',
    emptyDescription: 'Cadastre redes para vincular aos projetos.',
    editTooltip: 'Editar',
    deleteTooltip: 'Excluir',
    createModalTitle: 'Nova rede',
    editModalTitle: 'Editar rede',
    nameLabel: 'Nome',
    namePlaceholder: 'Ex.: Rede Metropolitana',
    acronymLabel: 'Sigla',
    acronymPlaceholder: 'Ex.: ABC',
    enableAcronymEdit: 'Habilitar edição da sigla',
    statusHelpActive: 'Rede disponível para novos projetos',
    statusHelpInactive: 'Rede inativa',
    cancel: 'Cancelar',
    save: 'Salvar',
    deleteHeader: 'Excluir rede',
    deleteMessage: 'Tem certeza que deseja excluir a rede "{name}"?',
    deleteAccept: 'Sim, excluir',
    loadError: 'Erro ao carregar redes',
    saveError: 'Erro ao salvar rede',
    deleteError: 'Erro ao excluir rede',
    createSuccess: 'Rede criada com sucesso',
    updateSuccess: 'Rede atualizada com sucesso',
    deleteSuccess: 'Rede excluída com sucesso',
    nameRequired: 'Informe o nome da rede',
    nameMaxLength: 'O nome deve ter no máximo 64 caracteres',
    acronymRequired: 'Informe a sigla da rede',
    acronymMaxLength: 'A sigla deve ter no máximo 5 caracteres',
};
